<div *ngIf="!currentInstanceRecord?.status && instance.id === currentInstanceRecord?.instanceId">
  <div class="configuration-application-state in-progress" *ngIf="instance.id === currentInstanceRecord?.instanceId && (!currentInstanceRecord?.status) && (currentInstanceRecord?.remainingTime < configStateMessageExpireTime || configurationState?.status === ConfigurationApplicationStatus.CONFIGURE_FAILED || configurationState?.status === ConfigurationApplicationStatus.TEST_FAILED)"
    [ngClass]="[configurationState.status === ConfigurationApplicationStatus.SUCCESS ? 'success' : 'in-progress']">
    <div class="flex flex-row justify-center items-center content">
      <ng-container *ngIf="configurationState.status | isIn: STEPS[STEPS.length - 1].completedStates; else updateInProgress">
        <div *ngIf="configurationState.status === ConfigurationApplicationStatus.SUCCESS; else updateFailed" class="flex items-center">
          <mat-icon svgIcon="done" class="mr-12"></mat-icon>
          {{ 'CONFIGURATIONS.STATE.UPDATE_APPLIED_SUCCESSFULLY' | transloco }}
          <div class="cursor-pointer ml-40" (click)="viewUpdateResults($event)">
            {{ 'CONFIGURATIONS.STATE.VIEW_RESULTS' | transloco }}
          </div>
        </div>
        <ng-template #updateFailed>
          <div *ngIf="configurationState.status === ConfigurationApplicationStatus.CONFIGURE_FAILED || configurationState.status === ConfigurationApplicationStatus.TEST_FAILED" class="flex items-center warn-solid-fg">
            <mat-icon svgIcon="info" class="mr-12"></mat-icon>
            <div>{{ 'CONFIGURATIONS.STATE.UPDATE_FAILED' | transloco }}</div>
            <div class="cursor-pointer  ml-40 mr-32" (click)="viewUpdateResults($event)">
              {{ 'CONFIGURATIONS.STATE.VIEW_RESULTS' | transloco }}
            </div>
            <div *ngIf="instance?.dataZone === DataZone.DEVELOPMENT && permissionsMap.RETRY" class="cursor-pointer ml-40" (click)="doRetry($event)">{{ 'CONFIGURATIONS.STATE.RETRY' | transloco }}</div>
            <!-- <div *ngIf="!(instance.environment === ('CONFIGURATIONS.STATE.LIVE' | transloco) && permissionsMap.RETRY) && (permissionsMap.RETRY || permissionsMap.APPLY_RELEASE_PACKAGE_HOTFIX && !permissionsMap.APPLY_RELEASE_PACKAGE_TILL_TEST || (permissionsMap.APPLY_RELEASE_PACKAGE_TILL_TEST && instance.deploymentClass !== 'B' && instance.deploymentClass !== 'A'))" class="cursor-pointer  ml-40" (click)="doRetry($event)">{{ 'CONFIGURATIONS.STATE.RETRY' | transloco }}</div>           -->
          </div>
        </ng-template>
      </ng-container>

      <ng-template #updateInProgress>
        <ng-container *ngIf="configurationState.skipTest === 'false'">
          <div *ngFor="let step of STEPS; let i = index;" class="step mr-8"
            [ngClass]="{'successful' : (configurationState.status | isIn: step.completedStates),
              'active': configurationState.status | isIn : STEPS[i].activeStates}">
              <mat-icon *ngIf="configurationState.status | isIn: step.completedStates; else stepNumber" svgIcon="done"
                class="icon-sm">
              </mat-icon>
              <ng-template #stepNumber>
                {{i + 1}}
              </ng-template>
          </div>
        </ng-container>

        <div class="flex flex-row items-center ml-40">
          <mat-icon svgIcon="change_circle" class="icon-sm mr-8"></mat-icon>
          <div *ngIf="configurationState.skipTest === 'false'; else deployUpdate">
            {{ (STEPS | find : 'activeStates' : configurationState.status)?.text | transloco }}
          </div>
          <ng-template #deployUpdate>
            {{ 'CONFIGURATIONS.STATE.APPLYING_CONFIGURATION' | transloco }}
          </ng-template>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<div *ngIf="configStateVerify && instance.environment === ('CONFIGURATIONS.STATE.LIVE' | transloco)">
  <div class="configuration-application-state in-progress"
    [ngClass]="[configurationState.status === ConfigurationApplicationStatus.VERIFIED ? 'success' : 'in-progress']">
    <div class="flex flex-row justify-center items-center content">
      <ng-container *ngIf="configurationState.status | isIn: STEPS[STEPS.length - 1].completedStates; else updateInProgress">
        <div *ngIf="configurationState.status === ConfigurationApplicationStatus.VERIFIED; else updateFailed" class="flex items-center">
          <mat-icon svgIcon="done" class="mr-12"></mat-icon>
          {{ 'CONFIGURATIONS.STATE.UPDATE_VERIFIED_SUCCESSFULLY' | transloco }}
          <div class="cursor-pointer  ml-40" (click)="viewUpdateResults($event)">
            {{ 'CONFIGURATIONS.STATE.VIEW_RESULTS' | transloco }}
          </div>
        </div>
        <ng-template #updateFailed>
          <div *ngIf="configurationState.status === ConfigurationApplicationStatus.VERIFICATION_FAILED" class="flex items-center warn-solid-fg">
            <mat-icon svgIcon="info" class="mr-12"></mat-icon>
            <div>{{ 'CONFIGURATIONS.STATE.UPDATE_FAILED' | transloco }}</div>
            <div class="cursor-pointer  ml-40 mr-32" (click)="viewUpdateResults($event)">
              {{ 'CONFIGURATIONS.STATE.VIEW_RESULTS' | transloco }}
            </div>
            <div *ngIf="!(instance.environment === ('CONFIGURATIONS.STATE.LIVE' | transloco) && permissionsMap.RETRY) && (permissionsMap.RETRY || permissionsMap.APPLY_RELEASE_PACKAGE_HOTFIX && (!permissionsMap.APPLY_RELEASE_PACKAGE_TILL_TEST || (permissionsMap.APPLY_RELEASE_PACKAGE_TILL_TEST && instance.deploymentClass !== 'B' && instance.deploymentClass !== 'A')))" class="cursor-pointer  ml-40" (click)="doRetry($event)">{{ 'CONFIGURATIONS.STATE.RETRY' | transloco }}</div>          </div>
        </ng-template>
      </ng-container>

      <ng-template #updateInProgress>
        <div class="button-container">
          <div class="spinner-container">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
          <div class="ml-34">{{ 'CONFIGURATIONS.STATE.VERIFY_DEPLOYING' | transloco }}</div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
